import { Step } from 'react-joyride';

export const schedulerTourSteps: Step[] = [
  {
    target: '[data-tour="scheduler-header"]',
    content: (
      <div>
        <h4>Report Scheduler</h4>
        <p>
          Automate your reporting workflow by scheduling reports to be generated and sent via email
          at regular intervals.
        </p>
      </div>
    ),
    placement: 'bottom',
    disableBeacon: true
  },
  {
    target: '[data-tour="create-schedule-button"]',
    content: (
      <div>
        <h4>Create New Schedule</h4>
        <p>
          Click here to create a new report schedule. Choose the report type, frequency (daily,
          weekly, monthly), and recipients.
        </p>
      </div>
    ),
    placement: 'bottom'
  },
  {
    target: '[data-tour="search-schedules"]',
    content: (
      <div>
        <h4>Search Schedules</h4>
        <p>Search for specific report schedules by name, type, or recipient email.</p>
      </div>
    ),
    placement: 'bottom'
  },
  {
    target: '[data-tour="schedules-table"]',
    content: (
      <div>
        <h4>Schedules List</h4>
        <p>
          View all your scheduled reports with their frequency, next run time, and recipients. Manage
          or delete schedules as needed.
        </p>
      </div>
    ),
    placement: 'top'
  }
];
